import _construct from "C:/Users/Marie/Desktop/2022/april/meh/my-gatsby-site/node_modules/@babel/runtime/helpers/esm/construct.js";
import _classCallCheck from "C:/Users/Marie/Desktop/2022/april/meh/my-gatsby-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/Marie/Desktop/2022/april/meh/my-gatsby-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "C:/Users/Marie/Desktop/2022/april/meh/my-gatsby-site/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "C:/Users/Marie/Desktop/2022/april/meh/my-gatsby-site/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "C:/Users/Marie/Desktop/2022/april/meh/my-gatsby-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/Marie/Desktop/2022/april/meh/my-gatsby-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/Marie/Desktop/2022/april/meh/my-gatsby-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseObject, assign, copy, flat, get, init, merge, set } from './__util__';

var Fill = /*#__PURE__*/function (_BaseObject) {
  _inherits(Fill, _BaseObject);

  var _super = _createSuper(Fill);

  function Fill() {
    var _this;

    _classCallCheck(this, Fill);

    _this = _super.call(this);
    init(_assertThisInitialized(_this));

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    assign.apply(void 0, [_assertThisInitialized(_this)].concat(args));
    return _this;
  }

  _createClass(Fill, [{
    key: "aggregate",
    value: function aggregate(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "aggregate", value);
        return obj;
      } else {
        return get(this, "aggregate");
      }
    }
  }, {
    key: "bandPosition",
    value: function bandPosition(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "bandPosition", value);
        return obj;
      } else {
        return get(this, "bandPosition");
      }
    }
  }, {
    key: "bin",
    value: function bin(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "bin", value);
        return obj;
      } else {
        return get(this, "bin");
      }
    }
  }, {
    key: "condition",
    value: function condition() {
      for (var _len2 = arguments.length, value = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        value[_key2] = arguments[_key2];
      }

      if (arguments.length) {
        var obj = copy(this);

        if (value.length === 1 && !Array.isArray(value[0])) {
          value = value[0];
        } else {
          value = flat(value);
        }

        set(obj, "condition", value);
        return obj;
      } else {
        return get(this, "condition");
      }
    }
  }, {
    key: "field",
    value: function field(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "legend",
    value: function legend(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "legend", value);
        return obj;
      } else {
        return get(this, "legend");
      }
    }
  }, {
    key: "scale",
    value: function scale(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "scale", value);
        return obj;
      } else {
        return get(this, "scale");
      }
    }
  }, {
    key: "sort",
    value: function sort(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "sort", value);
        return obj;
      } else {
        return get(this, "sort");
      }
    }
  }, {
    key: "timeUnit",
    value: function timeUnit(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "timeUnit", value);
        return obj;
      } else {
        return get(this, "timeUnit");
      }
    }
  }, {
    key: "title",
    value: function title(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "title", value);
        return obj;
      } else {
        return get(this, "title");
      }
    }
  }, {
    key: "type",
    value: function type(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "type", value);
        return obj;
      } else {
        return get(this, "type");
      }
    }
  }, {
    key: "datum",
    value: function datum(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "datum", value);
        return obj;
      } else {
        return get(this, "datum");
      }
    }
  }, {
    key: "value",
    value: function value(_value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "value", _value);
        return obj;
      } else {
        return get(this, "value");
      }
    }
  }, {
    key: "fieldN",
    value: function fieldN(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "nominal");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "fieldO",
    value: function fieldO(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "ordinal");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "fieldQ",
    value: function fieldQ(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "fieldT",
    value: function fieldT(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "if",
    value: function _if() {
      for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        values[_key3] = arguments[_key3];
      }

      if (values.length) {
        values[0] = {
          test: values[0]
        };
      }

      if (arguments.length) {
        var val = get(this, "condition") || [];
        var obj = copy(this);
        values = [].concat(val, merge(0, values));
        set(obj, "condition", values.length > 1 ? values : values[0]);
        return obj;
      } else {
        return get(this, "condition");
      }
    }
  }, {
    key: "count",
    value: function count() {
      var obj = copy(this);
      set(obj, "type", "quantitative");
      set(obj, "aggregate", "count");
      return obj;
    }
  }, {
    key: "valid",
    value: function valid(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "valid");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "missing",
    value: function missing(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "missing");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "distinct",
    value: function distinct(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "distinct");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "sum",
    value: function sum(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "sum");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "mean",
    value: function mean(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "mean");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "product",
    value: function product(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "product");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "average",
    value: function average(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "average");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "variance",
    value: function variance(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "variance");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "variancep",
    value: function variancep(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "variancep");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "stdev",
    value: function stdev(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "stdev");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "stdevp",
    value: function stdevp(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "stdevp");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "stderr",
    value: function stderr(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "stderr");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "median",
    value: function median(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "median");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "q1",
    value: function q1(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "q1");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "q3",
    value: function q3(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "q3");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "ci0",
    value: function ci0(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "ci0");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "ci1",
    value: function ci1(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "ci1");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "min",
    value: function min(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "min");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "max",
    value: function max(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "max");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "argmin",
    value: function argmin(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "argmin");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "argmax",
    value: function argmax(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "quantitative");
        set(obj, "aggregate", "argmax");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "year",
    value: function year(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "year");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "quarter",
    value: function quarter(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "quarter");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "month",
    value: function month(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "month");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "day",
    value: function day(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "day");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "date",
    value: function date(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "date");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "hours",
    value: function hours(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "hours");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "minutes",
    value: function minutes(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "minutes");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "seconds",
    value: function seconds(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "seconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "milliseconds",
    value: function milliseconds(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "milliseconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "yearmonth",
    value: function yearmonth(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "yearmonth");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeYQ",
    value: function timeYQ(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "yearquarter");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeYQM",
    value: function timeYQM(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "yearquartermonth");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeYM",
    value: function timeYM(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "yearmonth");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeYMD",
    value: function timeYMD(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "yearmonthdate");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeYMDH",
    value: function timeYMDH(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "yearmonthdatehours");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeYMDHM",
    value: function timeYMDHM(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "yearmonthdatehoursminutes");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeYMDHMS",
    value: function timeYMDHMS(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "yearmonthdatehoursminutesseconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeQM",
    value: function timeQM(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "quartermonth");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeMD",
    value: function timeMD(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "monthdate");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeMDH",
    value: function timeMDH(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "monthdatehours");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeHM",
    value: function timeHM(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "hoursminutes");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeHMS",
    value: function timeHMS(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "hoursminutesseconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeMS",
    value: function timeMS(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "minutesseconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "timeSMS",
    value: function timeSMS(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "secondsmilliseconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcyear",
    value: function utcyear(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcyear");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcquarter",
    value: function utcquarter(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcquarter");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcmonth",
    value: function utcmonth(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcmonth");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcday",
    value: function utcday(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcday");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcdate",
    value: function utcdate(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcdate");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utchours",
    value: function utchours(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utchours");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcminutes",
    value: function utcminutes(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcminutes");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcseconds",
    value: function utcseconds(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcseconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcmilliseconds",
    value: function utcmilliseconds(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcmilliseconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcyearmonth",
    value: function utcyearmonth(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcyearmonth");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcYQ",
    value: function utcYQ(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcyearquarter");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcYQM",
    value: function utcYQM(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcyearquartermonth");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcYM",
    value: function utcYM(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcyearmonth");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcYMD",
    value: function utcYMD(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcyearmonthdate");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcYMDH",
    value: function utcYMDH(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcyearmonthdatehours");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcYMDHM",
    value: function utcYMDHM(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcyearmonthdatehoursminutes");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcYMDHMS",
    value: function utcYMDHMS(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcyearmonthdatehoursminutesseconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcQM",
    value: function utcQM(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcquartermonth");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcMD",
    value: function utcMD(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcmonthdate");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcMDH",
    value: function utcMDH(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcmonthdatehours");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcHM",
    value: function utcHM(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utchoursminutes");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcHMS",
    value: function utcHMS(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utchoursminutesseconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcMS",
    value: function utcMS(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcminutesseconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "utcSMS",
    value: function utcSMS(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "field", value);
        set(obj, "type", "temporal");
        set(obj, "timeUnit", "utcsecondsmilliseconds");
        return obj;
      } else {
        return get(this, "field");
      }
    }
  }, {
    key: "toObject",
    value: function toObject(flag) {
      return flag ? {
        fill: _get(_getPrototypeOf(Fill.prototype), "toObject", this).call(this)
      } : _get(_getPrototypeOf(Fill.prototype), "toObject", this).call(this);
    }
  }]);

  return Fill;
}(BaseObject);

export function fill() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return _construct(Fill, args);
}